/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 首页推广
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
@BindAll()
export class PromotionalController {
  Model = new BaseModel({ type: 'object' });
  /** 智能推荐 */
  @computed
  get referral() {
    return this.Model.get('referral', []);
  }
  // 迁移到了 platform.config.ts
  // get referralTitle() {
  //   return '智能推荐';
  // }
  /** 推优季活动 */
  @computed
  get discount() {
    return this.Model.get('discount', []);
  }
  // 迁移到了 platform.config.ts
  // get discountTitle() {
  //   return '年终服务节专区';
  // }
  async getReferral() {
    const res = await AjaxBasics.request(EnumAPI.product_recommendList);
    this.Model.merge({ referral: lodash.get(res, 'list.productList') });
  }
  async getDiscount() {
    const res = await AjaxBasics.request(EnumAPI.product_starProducts);
    this.Model.merge({ discount: lodash.get(res, 'list.productList') });
  }
}
